import { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";

import { PropsWithClassName } from "../../common/types/PropsWithClassName";
import { TicketFilter } from "./ticketFilter";
import { fetchTicketFilters } from "./ticketFilterApi";
import NoResultsFound from "../../common/components/noResultsFound/NoResultsFound";
import { LS_LAST_USED_TICKET_FILTER_ID } from "../../common/utils/common";

interface TicketFiltersDropdownProps extends PropsWithClassName {
  departmentId: string;
  onChange: (filter: TicketFilter) => void;
}

export default function TicketFiltersDropdown({ className, departmentId, onChange }: TicketFiltersDropdownProps) {
  const lastUsedTicketFilterId = localStorage.getItem(LS_LAST_USED_TICKET_FILTER_ID);
  const [ticketFilters, setTicketFilters] = useState<TicketFilter[]>();
  const [selectedTicketFilter, setSelectedTicketFilter] = useState<TicketFilter>();

  useEffect(() => {
    const fetchTicketFiltersByDepartmentId = async () => {
      const filters = await fetchTicketFilters();
      const filtersByDepartmentId = filters.filter((ticketFilter: TicketFilter) => ticketFilter.departmentId === departmentId);
      setTicketFilters(filtersByDepartmentId);
    };

    fetchTicketFiltersByDepartmentId();
  }, [departmentId]);

  useEffect(() => {
    const selected = ticketFilters?.find((f) => f.id === lastUsedTicketFilterId);
    setSelectedTicketFilter(selected);
    // TODO: This should probably emit onChange
  }, [lastUsedTicketFilterId, ticketFilters]);

  return (
    <Dropdown
      className={`${className}`}
      placeholder="Selecteaza filtru"
      showClear
      optionLabel="name"
      options={ticketFilters}
      value={selectedTicketFilter}
      emptyMessage={<NoResultsFound />}
      onChange={(e) => onChange(e.value)}
    />
  );
}
